<app-base-action-modal
  modalTitle="Remove this Contact?"
  i18n-modalTitle
  primaryLabel="Remove Contact"
  i18n-primaryLabel
  secondaryLabel="Cancel"
  i18n-secondaryLabel
  (closeClicked)="close()"
  (primaryClicked)="confirm()"
  (secondaryClicked)="close()">
  <div class="remove-copy" i18n>Are you sure you want to remove {{ contactName }} as a contact for the employer?</div>
</app-base-action-modal>
